export default __webpack_public_path__ + "static/media/plus.e169406c.svg";